// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AnalyzerChartType;
(function (AnalyzerChartType) {
    AnalyzerChartType[AnalyzerChartType["PL"] = 0] = "PL";
    AnalyzerChartType[AnalyzerChartType["Delta"] = 1] = "Delta";
    AnalyzerChartType[AnalyzerChartType["Gamma"] = 2] = "Gamma";
    AnalyzerChartType[AnalyzerChartType["Vega"] = 3] = "Vega";
    AnalyzerChartType[AnalyzerChartType["Theta"] = 4] = "Theta";
    AnalyzerChartType[AnalyzerChartType["Rho"] = 5] = "Rho";
})(AnalyzerChartType || (AnalyzerChartType = {}));
